/**
 * Avatar component overrides.
 * Rounded avatars with subtle border.
 */

import type { Theme } from '@mui/material/styles';

const avatar: Theme['components'] = {
  MuiAvatar: {
    styleOverrides: {
      root: {
        backgroundColor: 'var(--mui-palette-Avatar-defaultBg)',
        border: '2px solid var(--glass-border)',
        fontWeight: 500,
      },
      rounded: {
        borderRadius: 'var(--mui-shape-customBorderRadius-md)',
      },
    },
  },
  MuiAvatarGroup: {
    styleOverrides: {
      root: {
        '& .MuiAvatar-root': {
          borderColor: 'var(--mui-palette-background-paper)',
        },
      },
    },
  },
};

export default avatar;
